(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("lazyload", [], factory);
	else if(typeof exports === 'object')
		exports["lazyload"] = factory();
	else
		root["lazyload"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 